<script>
  import Note from './Note.svelte';
  import { fade } from 'svelte/transition';
  import { CURRENT_CHAPTER_NOTES, TIME, CURRENT_CHAPTER, FOOTNOTE_HOVER_ID } from '../../stores.js';
  import { NOTE_SLIDE_UP_TIME, NOTE_FADE_OUT_TIME } from '../../config.js'
  import { between, isBetween } from '../../utils.js';
  import { watchResize } from 'svelte-watch-resize';
  import map from 'lodash/map';
  import some from 'lodash/some';
  import debounce from 'lodash/debounce';

  let width = 0;
  let height = 0;

  const noteHeight = 50;

  let currentTime;
  TIME.subscribe(v => {
    currentTime = v;
  });

  let notes;
  CURRENT_CHAPTER_NOTES.subscribe(value => {
    notes = value;
  });

  let currentChapterTitle;
  let currentChapterStart;
  let currentChapterEnd;
  let currentChapterNumber;
  CURRENT_CHAPTER.subscribe(({ end, number, start, title }) => {
    currentChapterTitle = title;
    currentChapterStart = start;
    currentChapterEnd = end; // TODO: Not needed
    currentChapterNumber = number;
  });

  let currentHoverID;
  FOOTNOTE_HOVER_ID.subscribe(v => {
    currentHoverID = v;
  });

  const handleEnter = debounce((id) => FOOTNOTE_HOVER_ID.set(id), 20)
  const handleLeave = debounce(() => FOOTNOTE_HOVER_ID.set(false), 20)

  $: elements = map(notes, (dot, i) => {
    const isActive = (!currentHoverID && isBetween(currentTime, dot.start, dot.end)) || currentHoverID === dot.index

    return {
      ...dot,
      isActive,
      style: `flex-grow: ${isActive ? '1' : '0'}`,
    }
  })

  $: isAnyActive = some(elements, 'isActive')

  function resizeTimeline (node) {
    ({ width, height } = node.getBoundingClientRect());
  }
</script>

<ul class="notes" use:watchResize={resizeTimeline}>
  <li style={`flex-grow: ${isAnyActive ? '0' : '1'}`}>
    <Note
      startTime={currentChapterStart}
      text={currentChapterTitle}
      index={currentChapterNumber}
      isChapterTitle={true} />
  </li>
  {#each elements as { index, isActive, start, end, text, y, images, duration, captions, style }, i (index)}
  <li
    in:fade="{{ duration: 300 }}"
    on:mouseenter={() => handleEnter(index)}
    on:mouseleave={() => handleLeave()}
    style={style}
    class:isActive={isActive}>
    <Note
      startTime={start}
      isActive={isActive}
      text={text}
      images={images}
      index={index}
      captions={captions} />
  </li>
  {/each}
</ul>
